// header.jsx
import React, { useState } from 'react';
import mapIcon from '../../../assets/icons/interface/mapPinHeader.svg';
import { useLocation } from 'react-router-dom';

const Header = ({ message }) => {
    const [menuOpen, setMenuOpen]     = useState(false);
    const [isClosing, setIsClosing]   = useState(false);
    const [showAuth, setShowAuth]     = useState(false);
    const [login, setLogin]           = useState('');
    const [password, setPassword]     = useState('');
    const [error, setError]           = useState('');
    const animationDuration          = 300; // ms, совпадает с CSS

    const { pathname, search } = useLocation();
    const params    = new URLSearchParams(search);
    const isDevPage = params.get('login') === 'admin'
        && params.get('password') === 'secret';

    // режим «Панорама» или «Разработка»
    const isPanoramaPage = pathname === '/panorama';
    const showMapBack    = isPanoramaPage || isDevPage;
    const firstText      = showMapBack ? 'Обычная карта' : 'Панорамы';

    // переключаем меню с анимацией
    const toggleMenu = () => {
        if (menuOpen) {
            setIsClosing(true);
            setTimeout(() => {
                setMenuOpen(false);
                setIsClosing(false);
                setShowAuth(false);
            }, animationDuration);
        } else {
            setMenuOpen(true);
        }
    };

    // первый пункт: Панорамы ↔ Обычная карта
    const handlePanoramaClick = () => {
        const target = showMapBack ? '/' : '/panorama';
        window.location.href = target;
        toggleMenu();
    };

    // язык
    const handleLanguageClick = () => {
        alert('В разработке');
    };

    // обработка формы логина
    const handleAuthSubmit = e => {
        e.preventDefault();
        if (login === 'admin' && password === 'secret') {
            window.location.href = '/?login=admin&password=secret';
        } else {
            setError('Неверный логин или пароль');
        }
    };

    return (
        <header className="container">
            <div className="header__wrapper">

                <div className="header__label">
                    <div className="header__button">
                        <img src={mapIcon} alt="<Map> Icon"/>
                    </div>
                    <h1 className="street-header">
                        {message || 'Загрузка...'}
                    </h1>
                </div>

                {/* кнопка-триггер с анимированным гамбургером */}
                <div
                    className="header__button header__button--blue"
                    onClick={toggleMenu}
                >
                    <div className={`menu-icon ${menuOpen ? 'open' : ''}`}>
                        <span/>
                    </div>
                </div>

                {/* меню (показываем, пока идёт fade-in или fade-out) */}
                {(menuOpen || isClosing) && (
                    <div className={
                        `header__menu ${menuOpen ? 'fade-in' : ''} ${isClosing ? 'fade-out' : ''}`
                    }>
                        {showAuth ? (
                            <form className="header__auth-form" onSubmit={handleAuthSubmit}>
                                {error && <div className="header__auth-error">{error}</div>}
                                <input
                                    className="header__auth-input"
                                    type="text"
                                    value={login}
                                    onChange={e => setLogin(e.target.value)}
                                    placeholder="Логин"
                                />
                                <input
                                    className="header__auth-input"
                                    type="password"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    placeholder="Пароль"
                                />
                                <div className="header__auth-buttons">
                                    <button type="submit" className="header__auth-btn">
                                        Войти
                                    </button>
                                    <button
                                        type="button"
                                        className="header__auth-btn"
                                        onClick={() => setShowAuth(false)}
                                    >
                                        Отмена
                                    </button>
                                </div>
                            </form>
                        ) : (
                            <ul className="header__menu-list">
                                <li
                                    className="header__menu-item"
                                    onClick={handlePanoramaClick}
                                >
                                    {firstText}
                                </li>
                                <li
                                    className="header__menu-item"
                                    onClick={handleLanguageClick}
                                >
                                    Сменить язык
                                </li>
                                {!isDevPage && (
                                    <li
                                        className="header__menu-item"
                                        onClick={() => setShowAuth(true)}
                                    >
                                        Админка
                                    </li>
                                )}
                            </ul>
                        )}
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
